import { useState, useEffect } from 'react-x';

export function useExternalElementSize (selectorName) {

  const selectorSymbol = selectorName.substring(0,1);
  const selectorType = selectorSymbol === '#' ? 'id' : selectorSymbol === '.' ? 'class' : undefined;
  const element = selectorType === 'id' ? document.getElementById(selectorName) : selectorType === 'class' ? document.querySelector(selectorName) : undefined;

  const [elementSize, setElementSize] = useState({
    width: 0,
    height: 0
  });

  useEffect(() => {
    function handleResize () {
      if (element) {
        setElementSize({
          width: element.offsetWidth,
          height: element.offsetHeight
        });
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  return elementSize || {};
};